import { motion } from "framer-motion";
import clsx from "clsx";
import { Quote, Star } from "lucide-react";
import { useTranslation } from "react-i18next";

const AVATAR_TONES = {
  teal:
    "bg-gradient-to-br from-teal to-teal-2 text-white shadow-[0_6px_16px_rgba(15,118,110,0.35)]",
  gold:
    "bg-gradient-to-br from-gold to-gold-2 text-amber-950 shadow-[0_6px_16px_rgba(201,162,39,0.35)]",
};

export default function TestCard({ item, index = 0 }) {
  const { t } = useTranslation("landing");
  const { key, avatarTone } = item;

  return (
    <motion.article
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{
        delay: index * 0.1,
        duration: 0.7,
        ease: [0.16, 1, 0.3, 1],
      }}
      className={clsx(
        "group relative overflow-hidden rounded-card border border-line bg-surface p-6 transition-all duration-500 sm:p-8",
        "hover:-translate-y-2 hover:border-teal-3 hover:shadow-card-lg"
      )}
    >
      {/* نوار رنگی چپ که با hover باز می‌شه */}
      <span
        aria-hidden
        className={clsx(
          "pointer-events-none absolute top-0 h-0 w-[3px] rounded-full bg-gradient-to-b from-teal to-gold-2 transition-all duration-500 ease-snap",
          "start-0",
          "group-hover:h-full"
        )}
      />

      {/* Quote icon */}
      <Quote
        aria-hidden
        className="pointer-events-none absolute top-5 end-6 h-10 w-10 text-gold-2/35 sm:h-12 sm:w-12"
        strokeWidth={1.5}
      />

      {/* Stars */}
      <div
        className="mb-4 flex items-center gap-1 text-gold"
        aria-label="5 out of 5 stars"
      >
        {[0, 1, 2, 3, 4].map((i) => (
          <Star
            key={i}
            className="h-4 w-4 fill-current"
            strokeWidth={0}
          />
        ))}
      </div>

      {/* Text */}
      <p className="relative z-10 mb-6 text-[14.5px] leading-[2] text-ink-soft sm:text-[15px]">
        {t(`${key}.text`)}
      </p>

      {/* User */}
      <div className="flex items-center gap-3.5 border-t border-line pt-5">
        <div
          className={clsx(
            "grid h-11 w-11 shrink-0 place-items-center rounded-full text-[15px] font-extrabold sm:h-12 sm:w-12 sm:text-[16px]",
            AVATAR_TONES[avatarTone]
          )}
        >
          {t(`${key}.initials`)}
        </div>
        <div className="min-w-0">
          <b className="block truncate text-[14px] font-extrabold text-ink sm:text-[14.5px]">
            {t(`${key}.name`)}
          </b>
          <span className="block truncate text-[12px] text-ink-mute sm:text-[12.5px]">
            {t(`${key}.role`)}
          </span>
        </div>
      </div>
    </motion.article>
  );
}